export const isPayloadVersion = (
  targetVersion: number,
  version?: number
): boolean => {
  if (!version) {
    return targetVersion === 1;
  }
  return version === targetVersion;
};
